import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../libs/shared/helpers/src/internationalization/react';
import {fontSizes} from '../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface StartGuideProgressBar {
  // A whole number representing completion progress.
  completionPercentage: number;
  isBanner?: boolean;
}

/*
 * Style.
 */

interface StyledWrapperDivProps {
  $shouldSetWrapperHeight: boolean;
}
const StyledWrapperDiv = styled.div<StyledWrapperDivProps>`
  display: grid;
  grid-row-gap: 5px;
  height: ${(p) => (p.$shouldSetWrapperHeight ? `25px` : `0px`)};
`;

const StyledBarBackground = styled.div`
  width: 100%;
  height: 5px;
  background-color: ${(p) => p.theme.greys.shade30};
  border-radius: 10px;
`;

interface ProgressStyleProps {
  $progress: number;
}
const StyledProgressDiv = styled.div<ProgressStyleProps>`
  width: ${(p) => (p.$progress === 0 ? '5%' : `${p.$progress}%`)};
  height: 5px;
  background-color: ${(p) => p.theme.palette.green.shade40};
  border-radius: 10px;
`;

const StyledDescriptionDiv = styled.div`
  font-size: ${fontSizes.verySmall};
  color: ${(p) => p.theme.greys.shade60};
`;

/*
 * Component.
 */

export const StartGuideProgressBar: FC<StartGuideProgressBar> = ({completionPercentage, isBanner}) => {
  // Round to the nearest multiple of 5.
  const roundedCompletionPercentage = 5 * Math.round(completionPercentage / 5);

  return (
    <StyledWrapperDiv $shouldSetWrapperHeight={!isBanner}>
      <StyledBarBackground>
        <StyledProgressDiv $progress={roundedCompletionPercentage} />
      </StyledBarBackground>
      {!isBanner && (
        <StyledDescriptionDiv>{getProgressDescription(roundedCompletionPercentage)}</StyledDescriptionDiv>
      )}
    </StyledWrapperDiv>
  );
};

/*
 * Helpers.
 */

function getProgressDescription(completionPercentage: number) {
  return <Trans id="startguide-progressbar-description-default">{`${completionPercentage}% complete`}</Trans>;
}
